import FormularioBoletines from '../../components/boletines/FormularioBoletines';

const Boletines = () => (
  <div>
    <div style={{ marginBottom: '16px' }}>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#111827', margin: 0 }}>Boletines</h1>
      <p style={{ color: '#9ca3af', marginTop: '2px', marginBottom: 0, fontSize: '0.8rem' }}>
        Boletín de notas para menores
      </p>
    </div>
    <FormularioBoletines />
  </div>
);

export default Boletines;
